<template>
<div class="list">
  <div class="item" v-for="item in list" v-bind:key="item.id">
    <label>
      <input type="checkbox" v-model="item.check" :value="item.id" v-if="!item.children">
      <p :class="item.children?'item-title':''">{{item.title}}</p>
    </label>
    <list :list="item.children"></list>
  </div>
</div>
</template>
<script>
export default {
name: "List",
props: {
  list: Array
},
mounted() {
},
};
</script>
<style>
.item{
  display: inline-block;
}
.item label input{
  padding: 0 0 0 50px;
}
.item input,
.item p{
  font-size: 16px;
  display: inline-block;
  color: #3d3d3d;
}
.item p.item-title{
  font-size: 16px;
  color: #457AFF;
}
</style>


// WEBPACK FOOTER //
// src/components/comment/AuthorityList.vue